module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"lng_en":{"join":"join beauty pass","signIn":"sign in"},"lng_id":{"join":"Daftar Beauty Pass","signIn":"Masuk"},"lng_th":{"join":"สมัคร Beauty Pass","signIn":"ลงชื่อเข้าใช้"},"lng_zh":{"join":"加入Beauty Pass","signIn":"登入"},"lng_ko":{"join":"뷰티 패스 가입하기","signIn":"로그인"}}')
  delete Component.options._Ctor
}
